<template>
    <div class="goods" v-show="goodShow">
       <Head
            :headInfo='headInfo'
            @onClickLeft='onBack'
        />
        <!-- 商品banner图片 -->
        <BannerSwiper
            :isHotSale='goods.isHotSale'
            :pageWidth='pageWidth'
            :imgUrlList='goods.spuImgUrlList'
        />
        <div class="titleLine borderBot borderBotLeft0" :class="{'tiered': pricesList.length}">
            <div class="name">{{ goods.spuName }}</div>
            <div class="title">成为单分享会员，立享会员批发价</div>
        </div>
        <div class="mark  mtop20 borderBotLeft0 col999" :class="{'borderBot': goodsAttrList.length}" >
            <img class="serveImg" src="../../../assets/img/b2b/icon_zp.png" alt="">正品保障&店铺售后
        </div>
        <div class="mtop20" v-if="shopName">
            <ShopName :shopName='shopName' />
        </div>
        <div class="tab borderBot borderBotLeft0">
            <div class="item" :class="{'active': act === 1}" @click="act = 1">商品介绍</div>
        </div>
        <div class="content" v-html="goods.detail">
        </div>
        <div class="foot">
            <div class="item">

            </div>
            <div class="item2">
                <div class="btn">
                    <div class="btn1 btnRed" @click="onSelect">立即购买</div>
                </div>
            </div>
        </div>
        <van-overlay :show="showNew" @touchmove.prevent :z-index=10000 @click="showNew = false">
            <div class="wrapper" >
                <div class="overblock">
                    <img src="../../../assets/img/b2b/sharePic.png" alt="">
                </div>
            </div>
        </van-overlay>
    </div>
</template>
<script>
import Head from '../../common/head'
import { shopInfo } from '../api/api'
import { mapState, mapActions } from 'vuex'
import BannerSwiper from '../common/detail/bannerSwiper' // banner详情
import ShopName from '../common/shopNameTemplate' // 小店
export default {
    name: 'shareGoods',
    components: {
        Head,
        BannerSwiper,
        ShopName
    },
    data () {
        return {
            headInfo: {
                title: '商品详情'
            },
            showNew: false,
            salesPrice: [],
            retailPrice: [],
            pricesList: [],
            act: 1,
            popupVisible: false,
            popupVisible2: false,
            popupVisible3: false,
            popupVisible4: false,
            popupVisible5: false,
            popupVisible6: false,
            popupVisible7: false,
            positionPop: false,
            memberCode: '',
            merchantCode: '',
            operator: '',
            spuImgUrls: [], // 商品图片
            productPrice: '', // 价格
            goodsDetail: '', // 商品详情
            categoryList: [],
            faddish: 0,
            productParameters: [], // 详细参数
            goodsName: '', // 商品名称
            stockout: 0, // 是否缺货
            goodsCode: '', // 商品编号
            goodsDetailBack: '', // 商品详情页面返回页面
            shopName: '', // 会员店简称
            userPhone: '', // 访问者手机号码
            userName: '', // 访问者名称
            memberName: '',
            onDj: 0,
            specsName: '', // 规格
            statusData: '', // 商品状态
            getSpecsList: [],
            star2: false,
            listNum: {},
            listNum2: {},
            goodShow: false,
            goodsId: '',
            nums: 1,
            cartNum: 0,
            cartNum2: 0,
            height: 0,
            heightContent: '',
            activityName: '',
            activityList: [], // 活动列表
            couponsList: [], // 优惠券列表
            pageWidth: document.documentElement.clientWidth,
            tab: 0,
            goods: '',
            parameterList: [],
            parameterData: [],
            parameterCheck: [],
            skuData: [],
            skuDataList: [],
            sku: {},
            rebatePrice: 0,
            priceRebate: 0,
            rebatePriceHtml: '',
            specifications: [],
            maxRebate: 0,
            rebateList: '',
            spuShow: false,
            meanList: [],
            goodsAttrList: [],
            shareUrl: ''
        }
    },
    computed: {
        ...mapState({
            getUserInfo: state => state.b2b.userInfo
        })
    },
    methods: {
        ...mapActions(['setBuried', 'getRebateData', 'getGoodsDetailData', 'getActivityList']),
        onBack () {
            if (this.tab) {
                localStorage.removeItem('activityData')
                this.$router.push({ path: '/b2b/home/index' })
            } else {
                localStorage.removeItem('activityData')
                this.$router.push({ path: this.goodsDetailBack })
            }
        },
        penMeans (url) {
            location.href = url
        },
        onSelect () {
            this.showNew = true
        },
        onRebate () {
            this.popupVisible6 = true
        },

        onCancel () {
            this.buryPoint(27)
            this.popupVisible2 = false
        },
        onConpon (type) {
            if (type === 1) {
                this.popupVisible3 = true
            } else {
                this.popupVisible4 = true
            }
        },
        async getGoodsDetail (type) {
            if (type) {
                this.popupVisible2 = false
                this.popupVisible = false
            }
            try {
                await this.getGoodsDetailData({
                    id: this.goodsId,
                    memberCode: this.memberCode,
                    merchantCode: this.merchantCode
                }).then((data) => {
                    this.goodShow = true
                    this.goods = data
                    this.specifications = data.specifications ? JSON.parse(data.specifications) : []
                    this.spuImgUrls = data.spuImgUrls.split(',')
                    this.pricesList = data.skuDetailList[0]['ladderPriceList']
                    this.computedPrice(data.skuDetailList)
                    this.getShopInfo()
                })
            } catch (error) {
                // this.$router.push({ path: '/b2b/goods/error' })
            }
        },
        async getRebate (rebateData) {
            let arr = []
            let name = ''
            await this.getRebateData({
                skuNum: this.sku.quantity,
                skuId: this.sku.skuId
            }).then((data) => {
                this.rebatePrice = data.maxRebate
                if (!data.rebateBos || !data.rebateBos.length) {
                    return false
                }
                if (data.rebateBos.length === 1) {
                    this.priceRebate = data.rebateBos[0]['discount']
                }
                data.rebateBos.forEach((item) => {
                    if (item.type == 1) {
                        name = '直接返利' + item.discount + '%'
                    } else if (item.type == 2) {
                        name = '满' + item.reachValue + '金额返利' + item.discount + '%'
                    } else {
                        name = '满' + item.reachValue + '件返利' + item.discount + '%'
                    }
                    arr.push(name)
                })
                this.rebatePriceHtml = arr.join(',')
            })
        },
        computedPrice (skuPrice) {
            let salesPrice = []
            let retailPrice = []
            skuPrice.forEach(item => {
                salesPrice.push(item.salesPrice)
                retailPrice.push(item.retailPrice)
            })
            this.salesPrice = [...new Set(salesPrice)].sort((a, b) => {
                return a - b
            })
            this.retailPrice = [...new Set(retailPrice)].sort((a, b) => {
                return a - b
            })
        },
        async getActivity () {
            let nameArr = []
            await this.getActivityList({
                categoryId: this.goods.categoryId,
                memberCode: this.memberCode,
                merchantCode: this.merchantCode,
                productId: this.goodsId
            }).then((data) => {
                this.activityList = data.activities || []
                this.couponsList = data.coupons || []
                if (!data.activities) {
                    return false
                }
                data.activities.forEach((item, index) => {
                    if (item.activityType === 1) {
                        if (item.activityRule === 1) {
                            nameArr.push(this.getTitle(item.joinType) + '满' + item.reachValue + '元减' + item.activityValue + '元')
                        } else {
                            nameArr.push(this.getTitle(item.joinType) + '每满' + item.reachValue + '元减' + item.activityValue + '元')
                        }
                    } else {
                        nameArr.push(this.getTitle(item.joinType) + '全部' + item.reachValue + '件打' + item.activityValue + '折')
                    }
                })
                this.activityName = nameArr.join(',')
            })
        },
        async buryPoint (event) {
            this.setBuried({ event: event })
        },
        // 店铺信息
        async getShopInfo () {
            const { data } = await shopInfo({
                merchantCode: this.goods.merchantCode
            })
            this.shopName = data.shopName
        }
    },
    mounted () {
        // let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.pageWidth = document.documentElement.clientWidth
        this.goodsId = this.$route.query.id
        this.memberCode = this.$route.query.companyCode
        this.merchantCode = this.$route.query.organizationCode
        this.getGoodsDetail()
        var ua = window.navigator.userAgent.toLowerCase()
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            // 微信 打开埋点
            this.buryPoint(93)
        } else {
            this.buryPoint(87)
        }
    },
    beforeRouteEnter (to, from, next) {
        var ua = window.navigator.userAgent.toLowerCase()
        if (ua.match(/MicroMessenger/i) == 'micromessenger' && to.query.isWeixin) {
            // 微信
            next(vm => {
                vm.showNew = false
            })
        } else if (to.query.isWeixin) {
            // 判断原生
            // window.location.href = 'dfx://'
            setTimeout(function () {
                window.location.href = '/newshareh5/b2b/downdfx?id=' + to.query.id + '&type=' + to.query.type + '&invitationCode=' + to.query.invitationCode
                // this.$route.push({ path: '/common/downDfx', query: {} }) // android下载地址
            }, 500)
        } else {
            next(vm => {
                vm.showNew = false
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.overblock {
    width: 396px;
    height: 184px;
    right: 48px;
    top: 20px;
    position: absolute;
}
.serveImg {
    width: 32px;
    height: 32px;
    vertical-align: sub;
    padding-right: 4px;
}
.rebate {
    text-align: right;
    font-size: 24px;
    margin-top: 10px;
    color: #ff7a45;
}
.goods {
    font-size: 28px;
    padding-bottom: 200px;
    background: #f5f5f5;
    position: relative;
    width: 100%;
    &.isFixed {
        position: fixed !important;
    }
    .banner {
        height: 100vw;
        position: relative;
        span {
            position: fixed;
            width: 64px;
            height: 64px;
            top: 80px;
            left: 20px;
            z-index: 9;
        }
        .banner-parent {
            position: relative;
        }
        .banner-item {
            display: block;
            margin: auto;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
        /*img{
                display: inline-block;
                width: 100%;
                height: 100%;
                margin: 0 auto;
                background: #f2f3f5;
                object-fit: cover;
            }*/
    }
    .titleLine {
        font-size: 36px;
        color: #ff7a45;
        background: #ffffff;
        padding: 30px 32px;
        width: 100%;
        box-sizing: border-box;
        position: relative;
        &.tiered {
            padding: 0;
            .tieredUl {
                padding: 26px 0;
                height: 120px;
                box-sizing: border-box;
                background: linear-gradient(
                    90deg,
                    rgba(255, 122, 69, 1) 0%,
                    rgba(255, 51, 53, 1) 100%
                );
                display: flex;
                justify-content: space-around;
                .tieredLi {
                    flex: 1;
                    font-size: 28px;
                    color: #ffffff;
                    text-align: center;
                    span {
                        font-size: 20px;
                    }
                    .piece {
                        font-size: 20px;
                    }
                }
            }
            .name {
                padding: 28px 96px 28px 32px;
                margin-top: 0;
            }
        }
        .price {
            .money {
                height: 66px;
                line-height: 66px;
                sub {
                    font-size: 32px;
                    padding-right: 8px;
                }
            }
            .retail {
                margin-top: 8px;
                font-size: 26px;
                color: #ff4d4f;
            }
        }
        .duoPrice {
            position: absolute;
            top: 28px;
            right: 0;
            width: 88px;
            height: 44px;
            line-height: 44px;
            border-top-left-radius: 44px;
            border-bottom-left-radius: 44px;
            font-size: 24px;
            color: #fff;
            text-align: center;
            background: #ff7a45;
        }
        .name {
            font-size: 30px;
            color: #333333;
            line-height: 42px;
            margin-bottom: 18px;
            word-wrap: break-word;
            word-break: break-all;
            overflow: hidden;
        }
    }
    .arrAbte::after {
        position: absolute;
        content: "";
        top: 32px;
        right: 28px;
        width: 40px;
        height: 40px;
        background: url(../../../assets/img/b2b/system_help@2x.png) no-repeat;
        background-size: 100%;
    }
    .mark {
        font-size: 28px;
        position: relative;
        background-color: #ffffff;
        height: 96px;
        line-height: 96px;
        padding: 0 32px;
        .item {
            float: right;
            margin-right: 40px;
            width: 480px;
            color: #333333;
            text-align: left;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            &.coupon {
                span {
                    position: relative;
                    height: 44px;
                    line-height: 44px;
                    display: inline-block;
                    background: #fff1ec;
                    padding: 0 12px;
                    margin-right: 16px;
                    border-top: 1px solid #ff7a45;
                    border-bottom: 1px solid #ff7a45;
                    color: #ff4d4f;
                    &::before {
                        position: absolute;
                        content: "";
                        left: 0;
                        top: 0;
                        bottom: 0;
                        width: 5px;
                        height: 44px;
                        background: url(../../../assets/img/b2b/conponBg_01.png)
                            no-repeat;
                        background-size: 100%;
                    }
                    &::after {
                        position: absolute;
                        content: "";
                        right: 0;
                        top: 0;
                        bottom: 0;
                        width: 5px;
                        height: 44px;
                        background: url(../../../assets/img/b2b/conponBg_02.png)
                            no-repeat;
                        background-size: 100%;
                    }
                }
            }
        }
    }
    .tab {
        display: flex;
        justify-content: space-around;
        height: 88px;
        line-height: 88px;
        background: #ffffff;
        margin-top: 20px;
        position: relative;
        .item {
            width: 50%;
            text-align: center;
            &.active {
                color: #ff7a45;
                border-bottom: 4px solid #ff7a45;
            }
        }
    }
    .content {
        background: #fff;
        text-align: center;
    }
    .content2 {
        padding: 32px;
        background: #fff;
        line-height: 48px;
        color: #666666;
        font-size: 28px;
        img {
            width: auto;
            height: auto;
        }
    }
    .foot {
        background: #ffffff;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 32px 32px 32px 32px;
        display: flex;
        justify-content: space-between;
        .item {
            display: flex;
            text-align: center;
            font-size: 20px;
            .itemSc {
                position: relative;
                width: 80px;
                text-align: center;
                margin-right: 20px;
                top: -8px;
                .name {
                    color: #999999;
                    transform: scale(0.75);
                    position: absolute;
                    width: 100%;
                    text-align: center;
                    top: 48px;
                    left: 0;
                }
            }
            span {
                width: 48px;
                height: 48px;
                display: inline-block;
                position: relative;
                .c1 {
                    position: absolute;
                    font-size: 20px;
                    top: -20px;
                    right: -20px;
                    width: 36px;
                    height: 36px;
                    line-height: 36px;
                    letter-spacing: -2px;
                    background: #ff7a45;
                    color: #fff;
                    text-align: center;
                    border-radius: 36px;
                }
                .c2 {
                    width: auto;
                }
                &.cart {
                    background: url(../../../assets/img/b2b/cart.png) no-repeat;
                    background-size: 100% 100%;
                }
                &.star {
                    background: url(../../../assets/img/b2b/star.png) no-repeat;
                    background-size: 100% 100%;
                }
                &.star2 {
                    background: url(../../../assets/img/b2b/icon_star_pre@2x.png)
                        no-repeat;
                    background-size: 100% 100%;
                }
            }
        }
        .item2 {
            .btn {
                display: flex;
                justify-content: space-between;
                .btn1 {
                    width: 208px;
                    height: 64px;
                    line-height: 64px;
                    // border: 3px solid #FF7A45;
                    border-radius: 64px;
                    text-align: center;
                    margin-left: 20px;
                    color: #ff7a45;
                    &.btnBg {
                        background: #ff7a45;
                        color: #ffffff;
                    }
                    &.btnRed {
                        background: #ff4d4f;
                        color: #ffffff;
                    }
                }
                .oos {
                    width: 436px;
                    color: #c7c7c7;
                    border: 2px solid #eaeaea;
                    background: #eaeaea;
                }
            }
        }
    }
}
.mint-popup-bottom {
    width: 100%;
    background: #f5f5f5;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    .conpon {
        background: #ffffff;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        .head {
            position: relative;
            height: 108px;
            line-height: 108px;
            padding: 0 24px;
            .close {
                width: 48px;
                height: 48px;
                position: absolute;
                right: 24px;
                top: 10px;
            }
        }
        .conponLi {
            background: #ffffff;
            padding: 0 0 0 32px;
            height: 850px;
            overflow-y: auto;
            .shaky {
                position: relative;
                padding: 32px 0;
                &.arrow2:after {
                    top: 48px;
                }
                .title4 {
                    padding-left: 76px;
                    &.m1::before {
                        position: absolute;
                        top: 38px;
                        left: 0;
                        content: "";
                        width: 56px;
                        height: 28px;
                        background: url(../../../assets/img/b2b/m1.png)
                            no-repeat;
                        background-size: 100% 100%;
                    }
                    &.m2::before {
                        position: absolute;
                        top: 38px;
                        left: 0;
                        content: "";
                        width: 56px;
                        height: 28px;
                        background: url(../../../assets/img/b2b/m2.png)
                            no-repeat;
                        background-size: 100% 100%;
                    }
                    h3 {
                        margin-bottom: 4px;
                    }
                }
            }
        }
        .server {
            height: 900px;
            padding: 32px;
            .ratePrice {
                margin-bottom: 80px;
            }
            .rabateSm {
                margin-bottom: 48px;
                .title {
                    margin-bottom: 16px;
                }
            }
            // p{
            //     margin-bottom: 40px;
            // }
        }
        .means {
            height: 900px;
            padding: 32px;
            overflow: auto;
            .meanLi {
                display: flex;
                justify-content: flex-start;
                font-size: 32px;
                color: #333333;
                line-height: 84px;
                height: 84px;
                margin-bottom: 40px;
                .meanLeft {
                    flex: 0 0 72px;
                    font-size: 0;
                }
                .meanRight {
                    margin-left: 20px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    overflow: hidden;
                    white-space: normal;
                    word-break: break-all;
                }
            }
        }
        .conponList {
            text-align: left;
            background: #f5f5f5;
            // padding: 20px 24px 44px;
            height: 800px;
            overflow-y: auto;
            .items {
                background: #ffffff;
                border-radius: 12px;
                margin-top: 20px;
                margin-left: 24px;
                margin-right: 24px;
                height: 224px;
                display: flex;
                justify-content: flex-start;
                h3 {
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    overflow: hidden;
                    white-space: normal;
                    word-break: break-all;
                }
                .itemLeft {
                    width: 224px;
                    line-height: 224px;
                    text-align: center;
                    background: url(../../../assets/img/b2b/coupon.png)
                        no-repeat;
                    background-size: 100% 100%;
                    font-family: SFUIDisplay-Bold;
                    font-weight: bold;
                    color: rgba(255, 255, 255, 1);
                    &.couponCopy {
                        background: url(../../../assets/img/b2b/couponCopy.png)
                            no-repeat;
                        background-size: 100% 100%;
                    }
                }
                .itemRight {
                    flex: 1;
                    padding: 32px 28px 0;
                    position: relative;
                    .title {
                        p {
                            margin-top: 6px;
                            font-size: 22px;
                        }
                    }
                    .time {
                        font-size: 22px;
                        margin-top: 26px;
                        white-space: nowrap;
                        transform: scale(0.95);
                        transform-origin: 0 0 0;
                    }
                    .progree {
                        width: 246px;
                        .pro {
                            margin-left: 14px;
                            transform: scale(0.95);
                            height: 0px;
                        }
                    }
                    .btn {
                        width: 144px;
                        height: 48px;
                        line-height: 48px;
                        text-align: center;
                        color: #ffffff;
                        border-radius: 48px;
                        font-size: 22px;
                        background: #ff834e;
                        position: absolute;
                        right: 16px;
                        bottom: 16px;
                    }
                    .btn2 {
                        background: #f5f5f5;
                        color: #c7c7c7;
                    }
                    &.effectImg {
                        background: url(../../../assets/img/b2b/img_user1.png)
                            no-repeat;
                        background-size: 112px 96px;
                        background-position: 366px 0;
                    }
                    &.effectImg2 {
                        background: url(../../../assets/img/b2b/img_user2.png)
                            no-repeat;
                        background-size: 112px 96px;
                        background-position: 366px 0;
                    }
                }
            }
        }
    }
    .select {
        padding: 24px;
        background: #ffffff;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        .head {
            display: flex;
            justify-content: space-between;
            position: relative;
            padding-bottom: 40px;
            .img {
                width: 220px;
                height: 220px;
                flex: 0 0 220px;
            }
            .title2 {
                margin-left: 24px;
                flex: 0 0 460px;
                display: flex;
                align-content: space-between;
                flex-wrap: wrap;
                .close {
                    flex: 0 0 100%;
                    overflow: hidden;
                    .img {
                        width: 48px;
                        height: 48px;
                        float: right;
                    }
                }
                .goodsBt {
                    .price {
                        flex: 0 0 100%;
                        font-size: 34px;
                        color: #ff7a45;
                        height: 48px;
                        sub {
                            font-size: 22px;
                        }
                        span {
                            font-size: 24px;
                            color: #999999;
                            margin-left: 32px;
                            text-decoration: line-through;
                            sub {
                                font-size: 16px;
                            }
                        }
                    }
                    .cont {
                        font-size: 24px;
                        color: #333333;
                        line-height: 36px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                    }
                    .gg {
                        font-size: 24px;
                        line-height: 30px;
                        height: 60px;
                        width: 360px;
                        margin-top: 12px;
                        color: #666666;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        word-wrap: break-word;
                        word-break: break-all;
                        overflow: hidden;
                    }
                }
            }
            &.borderBot:before {
                width: auto;
                left: 0;
            }
        }
        .selectYs {
            padding-bottom: 30px;
            position: relative;
            height: 400px;
            overflow-y: auto;
            border-bottom: 2px solid #eeeeee;
            &.borderBot:before {
                width: auto;
                left: 0;
            }
            .mtop40 {
                margin-top: 40px;
            }
            .it {
                font-size: 24px;
                display: flex;
                flex-wrap: wrap;
                align-content: flex-start;
                span {
                    border-radius: 10px;
                    background: #f5f5f5;
                    border: 2px solid #f5f5f5;
                    margin-top: 20px;
                    margin-right: 8px;
                    line-height: 60px;
                    height: 60px;
                    padding: 0 24px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    word-wrap: break-word;
                    word-break: break-all;
                    overflow: hidden;
                    &.active {
                        background: #fff9f9;
                        border: 2px solid #ff7a45;
                    }
                    &.disabld {
                        // pointer-events: none;
                        color: #c7c7c7;
                    }
                }
            }
        }
        .rebateList {
            display: flex;
            justify-content: flex-start;
            font-size: 28px;
            padding: 32px 0;
            border-bottom: 2px solid #eeeeee;
            position: relative;
            .rebateLeft {
                flex: 0 0 144px;
                color: #333333;
            }
            .rebateRight {
                color: #999999;
                line-height: 40px;
            }
        }
        .nums {
            display: flex;
            justify-content: space-between;
            margin-top: 28px;
            line-height: 60px;
            .num {
                display: flex;
                justify-content: flex-end;
                span {
                    display: inline-block;
                    width: 66px;
                    height: 60px;
                    line-height: 60px;
                    text-align: center;
                    &.jian {
                        background: url(../../../assets/img/b2b/btn_reduce@2x.png)
                            no-repeat;
                        background-size: 100% 100%;
                    }
                    &.jian2 {
                        background: url(../../../assets/img/b2b/btn_reduce_pre@2x.png)
                            no-repeat;
                        background-size: 100% 100%;
                    }
                    &.jia {
                        background: url(../../../assets/img/b2b/btn_add@2x.png)
                            no-repeat;
                        background-size: 100% 100%;
                    }
                    &.w38 {
                        width: 76px;
                        font-size: 32px;
                        background: #f5f5f5;
                        margin: 0 2px;
                    }
                }
            }
        }
    }
    .lines {
        background: #ffffff;
        height: 20px;
    }
    .fot {
        padding: 32px;
        background: #ffffff;
        .btn {
            display: flex;
            justify-content: center;
            .btn1 {
                width: 208px;
                height: 64px;
                line-height: 64px;
                // border: 2px solid #FF7A45;
                border-radius: 64px;
                text-align: center;
                margin: 0 10px;
                color: #ff7a45;
                &.btnBg {
                    background: #ff7a45;
                    color: #ffffff;
                }
                &.btnRed {
                    background: #ff4d4f;
                    color: #ffffff;
                }
                &.oss2 {
                    border: 0.026667rem solid #ccc;
                    color: #fff;
                    background: #ccc;
                    width: 100%;
                }
            }
        }
    }
}
.mint-zj {
    width: 95% !important;
    border-radius: 8px !important;
    background: none;
    .ps {
        border-radius: 8px;
        background: #ffffff;
        .item {
            padding: 32px;
            font-size: 32px;
            text-align: center;
            position: relative;
            &.borderBot:before {
                width: auto;
                left: 0;
            }
        }
    }
}
.mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
.padding-t {
    padding-top: 40px;
}
.padding-t2 {
    padding-top: 68px;
}
.mint-swipe-item {
    img.back {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }
}
.arrow2:after {
    top: 26px;
}
/deep/ .mint-swipe-indicator {
    width: 14px;
    height: 14px;
    margin: 10px;
}
/deep/ .mint-swipe-indicator.is-active {
    background: #ff7a45;
}
</style>
<style lang="scss">
body.dialog-open {
    position: fixed;
    width: 100%;
}
</style>
